import type { VoiceCallPhase, VoiceCallSession } from '../types/voice-call'

let session: VoiceCallSession | null = null
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

export function isTerminalCallPhase(phase: VoiceCallPhase): boolean {
  return phase === 'ended' || phase === 'idle'
}

export function getVoiceCallSession(): VoiceCallSession | null {
  return session
}

export function setVoiceCallSession(next: VoiceCallSession | null): void {
  session = next
  emit()
}

export function patchVoiceCallSession(patch: Partial<VoiceCallSession>): void {
  if (!session) return
  if (session.phase === 'ended') {
    // Never regress an ended call back to active/connecting (late Chime callbacks).
    const { phase, connectedAt, lastPeerHeartbeatAt, ...rest } = patch
    if (
      phase !== undefined ||
      connectedAt !== undefined ||
      lastPeerHeartbeatAt !== undefined
    ) {
      return
    }
    if (Object.keys(rest).length === 0) return
    session = { ...session, ...rest }
    emit()
    return
  }
  session = { ...session, ...patch }
  emit()
}

export function subscribeVoiceCallSession(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
